module.exports = __webpack_public_path__ + "img/search.5841f256.svg";